import {
  Column,
  RouteOptionViewSchema,
  RouteSectionViewSchema,
} from '@fsf/types';
import { _ } from '@ngx-translate/core';
import * as z from 'zod';

const RouteSectionSchema = RouteSectionViewSchema;

export type RouteSection = z.infer<typeof RouteSectionSchema>;

const RouteSchema = RouteOptionViewSchema.extend({
  sections: z.array(RouteSectionSchema),
});

export type Route = z.infer<typeof RouteSchema>;

const routeColumns: Column<keyof Route>[] = [
  {
    header: 'route.name',
    field: 'name',
    sortField: 'name',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
];

const routeSectionColumns: Column<keyof RouteSection>[] = [
  {
    header: _('routeSection.id'),
    field: 'id',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'routeSection.name',
    field: 'name',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'routeSection.type',
    field: 'type',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'routeSection.lastCheckedAt',
    field: 'last_checked_at',
    type: 'date',
    displayType: 'date',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
];

const globalFilterFields = ['name'];

export const RouteMetadata = {
  routeColumns,
  globalFilterFields,
};

export const RouteSectionMetadata = {
  routeSectionColumns,
  globalFilterFields,
};

export const StoreRouteSectionSchema = z.object({
  name: z.string().min(1).max(255),
  type: z.enum(['element', 'platform']),
  order: z.number().int().min(1),
});

export const UpdateRouteSectionSchema = StoreRouteSectionSchema.partial();

export const routeTranslations = _([
  'route.name',
  'routeSection.add',
  'routeSection.name',
  'routeSection.type',
  'routeSection.typeElement',
  'routeSection.typePlatform',
  'routeSection.order',
  'routeSection.created',
  'routeSection.createError',
  'routeSection.updated',
  'routeSection.updateError',
  'routeSection.deleteConfirmMessage',
  'routeSection.deleteHeader',
  'routeSection.lastCheckedAt',
]);
